<template>
  <div id="view">
    <historyTag :historyArr="historyArr"></historyTag>
    <div id="mainBox">
      <div class="topBox flex toolbarRow">
        <div class="filterRow">
          <span class="filterLabel">名称</span>
          <el-input
            v-model="queryDictName"
            clearable
            placeholder="模糊匹配字典名称"
            class="nameSearchInput"
            @keyup.enter.native="loadList"
          />
          <el-button type="primary" size="small" :loading="loading" @click="loadList">查询</el-button>
          <el-button size="small" :disabled="loading" @click="resetQuery">重置</el-button>
        </div>
      </div>

      <el-table v-loading="loading" border :data="tableData" style="width: 100%">
        <el-table-column label="名称" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.dictName || scope.row.dict_name }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="80" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.status === '1' ? '停用' : '正常' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip />
        <el-table-column label="操作" width="260" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="openTypeEdit(scope.row)">编辑</el-button>
            <el-button type="primary" plain size="mini" @click="openDictDataDialog(scope.row)">字典数据</el-button>
            <el-button type="text" size="mini" class="btnDanger" @click="confirmDeleteType(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      title="编辑字典类型"
      :visible.sync="typeEditDialogVisible"
      width="520px"
      custom-class="dictTypeEditDialog"
      @closed="onTypeEditClosed"
    >
      <el-form label-width="72px" size="small" class="typeEditForm">
        <el-form-item label="名称">
          <el-input
            v-model="typeEditForm.dictName"
            placeholder="字典名称"
            maxlength="200"
            show-word-limit
            clearable
          />
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="typeEditForm.remark"
            type="textarea"
            :rows="4"
            placeholder="备注说明"
            maxlength="500"
            show-word-limit
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="typeEditDialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" :loading="typeEditSaving" @click="saveTypeEdit">
          保 存
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="dataDialogTitle"
      :visible.sync="dataDialogVisible"
      width="900px"
      top="6vh"
      custom-class="dictDataDialog"
      @closed="onDialogClosed"
    >
      <div v-loading="dataDialogLoading" class="dialogBody">
        <div class="dataDialogToolbar">
          <el-button type="primary" size="small" :disabled="!dataDialogDictType" @click="openAddDictData">
            新增
          </el-button>
        </div>
        <el-table border :data="dataDialogRows" size="small" max-height="520">
          <el-table-column label="标签" min-width="140" show-overflow-tooltip>
            <template slot-scope="scope">{{ pick(scope.row, "dictLabel", "dict_label") }}</template>
          </el-table-column>
          <el-table-column label="键值（可编辑）" min-width="280">
            <template slot-scope="scope">
              <div class="valueEditRow">
                <el-input
                  v-model="scope.row._editDictValue"
                  size="small"
                  placeholder="dict_value"
                  clearable
                />
                <el-button
                  type="primary"
                  size="small"
                  :loading="!!scope.row._saving"
                  @click="saveDictValue(scope.row)"
                >
                  保存
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <p v-if="!dataDialogLoading && dataDialogRows.length === 0" class="dialogEmpty">该类型下暂无「正常」状态的字典项</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="dataDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="新增字典项"
      :visible.sync="addDictDataVisible"
      width="480px"
      append-to-body
      custom-class="dictDataAddDialog"
      @closed="onAddDictClosed"
    >
      <el-form label-width="72px" size="small" class="addDictForm">
        <el-form-item label="标签" required>
          <el-input v-model="addDictForm.dictLabel" maxlength="200" show-word-limit placeholder="展示文案 dict_label" />
        </el-form-item>
        <el-form-item label="键值" required>
          <el-input v-model="addDictForm.dictValue" maxlength="200" show-word-limit placeholder="枚举码 dict_value" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input
            v-model="addDictForm.dictSort"
            placeholder="留空则排在末尾（自动）"
            clearable
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="addDictDataVisible = false">取 消</el-button>
        <el-button type="primary" size="small" :loading="addDictSaving" @click="submitAddDictData">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      historyArr: ["字典管理", "字典类型"],
      queryDictName: "",
      tableData: [],
      loading: false,
      dataDialogVisible: false,
      dataDialogTitle: "字典数据",
      dataDialogDictType: "",
      dataDialogRows: [],
      dataDialogLoading: false,
      typeEditDialogVisible: false,
      typeEditSaving: false,
      typeEditForm: {
        dictId: null,
        dictName: "",
        remark: "",
      },
      addDictDataVisible: false,
      addDictSaving: false,
      addDictForm: {
        dictLabel: "",
        dictValue: "",
        dictSort: "",
      },
    };
  },
  mounted() {
    this.loadList();
  },
  methods: {
    pick(row, camelKey, snakeKey) {
      var v = row[camelKey];
      if (v !== undefined && v !== null) return v;
      if (row[snakeKey] !== undefined && row[snakeKey] !== null) return row[snakeKey];
      return "";
    },
    openTypeEdit(row) {
      var id = this.pick(row, "dictId", "dict_id");
      if (id === "" || id === undefined || id === null) {
        this.$message.warning("缺少主键 dict_id，无法编辑");
        return;
      }
      var numId = typeof id === "number" ? id : parseInt(id, 10);
      if (isNaN(numId)) {
        this.$message.warning("dict_id 非法");
        return;
      }
      var nm = this.pick(row, "dictName", "dict_name");
      var rk = row.remark;
      this.typeEditForm = {
        dictId: numId,
        dictName: nm != null ? String(nm) : "",
        remark: rk != null ? String(rk) : "",
      };
      this.typeEditDialogVisible = true;
    },
    onTypeEditClosed() {
      this.typeEditForm = { dictId: null, dictName: "", remark: "" };
      this.typeEditSaving = false;
    },
    saveTypeEdit() {
      if (!this.typeEditForm.dictId) {
        this.$message.warning("数据异常");
        return;
      }
      this.typeEditSaving = true;
      this.$https(this.$api.api.upMgmtDictType, {
        dictId: this.typeEditForm.dictId,
        dictName: this.typeEditForm.dictName != null ? this.typeEditForm.dictName : "",
        remark: this.typeEditForm.remark != null ? this.typeEditForm.remark : "",
      }, "POST")
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.$message.success("已保存");
            this.typeEditDialogVisible = false;
            this.loadList();
          } else {
            this.$message.error((res.data && res.data.msg) || "保存失败");
          }
        })
        .catch(() => {
          this.$message.error("网络错误");
        })
        .then(() => {
          this.typeEditSaving = false;
        });
    },
    confirmDeleteType(row) {
      var id = this.pick(row, "dictId", "dict_id");
      if (id === "" || id === undefined || id === null) {
        this.$message.warning("缺少主键 dict_id");
        return;
      }
      var numId = typeof id === "number" ? id : parseInt(id, 10);
      if (isNaN(numId)) {
        this.$message.warning("dict_id 非法");
        return;
      }
      var nm = this.pick(row, "dictName", "dict_name");
      var title = nm != null && String(nm).trim() !== "" ? String(nm).trim() : "该类型";
      var self = this;
      this.$confirm(
        "确定删除字典类型「" + title + "」吗？删除后不可恢复。若该类型下仍有字典数据将无法删除。",
        "删除确认",
        {
          confirmButtonText: "删除",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(function () {
          return self.$https(self.$api.api.delMgmtDictType, { dictId: numId }, "POST");
        })
        .then(function (res) {
          if (res.data && res.data.code === 200) {
            self.$message.success("已删除");
            self.loadList();
          } else {
            self.$message.error((res.data && res.data.msg) || "删除失败");
          }
        })
        .catch(function (err) {
          if (err === "cancel") return;
          self.$message.error("网络错误");
        });
    },
    openDictDataDialog(row) {
      var code = row.dictType || row.dict_type;
      code = code != null ? String(code).trim() : "";
      if (!code) {
        this.$message.warning("该行缺少类型编码");
        return;
      }
      var name = this.pick(row, "dictName", "dict_name");
      this.dataDialogDictType = code;
      this.dataDialogTitle = (name && String(name).trim()) ? "字典数据 · " + String(name).trim() : "字典数据";
      this.dataDialogVisible = true;
      this.loadDialogData();
    },
    onDialogClosed() {
      this.dataDialogRows = [];
      this.dataDialogDictType = "";
      this.addDictDataVisible = false;
      this.resetAddDictForm();
    },
    openAddDictData() {
      if (!this.dataDialogDictType) {
        this.$message.warning("类型编码缺失");
        return;
      }
      this.resetAddDictForm();
      this.addDictDataVisible = true;
    },
    resetAddDictForm() {
      this.addDictForm = { dictLabel: "", dictValue: "", dictSort: "" };
      this.addDictSaving = false;
    },
    onAddDictClosed() {
      this.resetAddDictForm();
    },
    submitAddDictData() {
      var label = (this.addDictForm.dictLabel || "").trim();
      var val = (this.addDictForm.dictValue || "").trim();
      if (!label) {
        this.$message.warning("请填写标签");
        return;
      }
      if (!val) {
        this.$message.warning("请填写键值");
        return;
      }
      if (!this.dataDialogDictType) {
        this.$message.warning("类型编码缺失");
        return;
      }
      var sortStr = (this.addDictForm.dictSort || "").trim();
      var payload = {
        dictType: this.dataDialogDictType,
        dictLabel: label,
        dictValue: val,
      };
      if (sortStr !== "") {
        var n = parseInt(sortStr, 10);
        if (isNaN(n)) {
          this.$message.warning("排序须为整数");
          return;
        }
        payload.dictSort = n;
      }
      var self = this;
      this.addDictSaving = true;
      this.$https(this.$api.api.addMgmtDictData, payload, "POST")
        .then(function (res) {
          if (res.data && res.data.code === 200) {
            self.$message.success("已新增");
            self.addDictDataVisible = false;
            self.loadDialogData();
          } else {
            self.$message.error((res.data && res.data.msg) || "新增失败");
          }
        })
        .catch(function () {
          self.$message.error("网络错误");
        })
        .then(function () {
          self.addDictSaving = false;
        });
    },
    loadDialogData() {
      if (!this.dataDialogDictType) return;
      this.dataDialogLoading = true;
      this.$https(
        this.$api.api.selMgmtDictDataList,
        { dictType: this.dataDialogDictType, status: "0" },
        "POST"
      )
        .then((res) => {
          if (res.data && res.data.code === 200) {
            var list = res.data.data || [];
            list.forEach((r) => {
              var dv = this.pick(r, "dictValue", "dict_value");
              this.$set(r, "_editDictValue", dv != null ? String(dv) : "");
              this.$set(r, "_saving", false);
            });
            this.dataDialogRows = list;
          } else {
            this.dataDialogRows = [];
            this.$message.error((res.data && res.data.msg) || "加载字典数据失败");
          }
        })
        .catch(() => {
          this.dataDialogRows = [];
          this.$message.error("网络错误");
        })
        .then(() => {
          this.dataDialogLoading = false;
        });
    },
    saveDictValue(row) {
      var code = this.pick(row, "dictCode", "dict_code");
      if (code === "" || code === undefined || code === null) {
        this.$message.warning("缺少 dict_code，无法保存");
        return;
      }
      var numCode = typeof code === "number" ? code : parseInt(code, 10);
      if (isNaN(numCode)) {
        this.$message.warning("dict_code 非法");
        return;
      }
      this.$set(row, "_saving", true);
      this.$https(
        this.$api.api.upMgmtDictDataValue,
        { dictCode: numCode, dictValue: row._editDictValue != null ? row._editDictValue : "" },
        "POST"
      )
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.$message.success("已保存");
            if (row.dictValue !== undefined) row.dictValue = row._editDictValue;
            if (row.dict_value !== undefined) row.dict_value = row._editDictValue;
          } else {
            this.$message.error((res.data && res.data.msg) || "保存失败");
          }
        })
        .catch(() => {
          this.$message.error("网络错误");
        })
        .then(() => {
          this.$set(row, "_saving", false);
        });
    },
    resetQuery() {
      this.queryDictName = "";
      this.loadList();
    },
    loadList() {
      this.loading = true;
      var body = {};
      var name = (this.queryDictName || "").trim();
      if (name) {
        body.dictName = name;
      }
      this.$https(this.$api.api.selMgmtDictTypeList, body, "POST")
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.tableData = res.data.data || [];
          } else {
            this.tableData = [];
            this.$message.error((res.data && res.data.msg) || "加载失败");
          }
        })
        .catch(() => {
          this.tableData = [];
          this.$message.error("网络错误");
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.topBox {
  margin-bottom: 12px;
}
.toolbarRow {
  margin-bottom: 4px;
}
.filterRow {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.filterLabel {
  margin-right: 8px;
  font-size: 14px;
  color: #606266;
}
.nameSearchInput {
  width: 260px;
  max-width: 100%;
  margin-right: 10px;
}
.btnDanger {
  color: #f56c6c;
}
.valueEditRow {
  display: flex;
  align-items: center;
}
.valueEditRow .el-input {
  flex: 1;
  min-width: 0;
}
.valueEditRow .el-button {
  flex-shrink: 0;
  margin-left: 8px;
}
.dialogBody {
  min-height: 120px;
}
.dialogEmpty {
  margin: 16px 0 0;
  text-align: center;
  color: #909399;
  font-size: 13px;
}
.dataDialogToolbar {
  margin-bottom: 12px;
}
</style>

<style>
.dictDataDialog .el-dialog__body {
  padding-top: 10px;
}
.dictTypeEditDialog .el-dialog__body {
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/dictMgmt/dictType/index.vue